import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Volume2, File } from 'react-feather';
import '../../styles/table.css'; // Importing the external CSS
import Grid from '@mui/material/Grid2';
import { ArrowLeft } from 'react-feather';
import { Typography, Avatar, Tabs, Tab, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import ChatApp from '../../components/Chat';
import ChatAppCopy from '../../components/Chat copy';
export default function MattersDetails({ apiResponse }) {
    const token = useSelector((state) => state.auth.token); // Get the token from Redux
    const userID = useSelector((state) => state.auth.id); // Get the userID from Redux
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [tab, setTab] = useState(0);
    const handleTabChange = (_, newValue) => {
        setTab(newValue);
    };
    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <File style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="#333333">
                        Matters Details
                    </Typography>
                </Box>
                {/* Right Section */}
                {apiResponse?.data?.actions?.add && (
                    <Button
                        variant="outlined"
                        component={Link}
                        to="/matters"
                        sx={{
                            backgroundColor: 'var(--back-button)',
                            color: "var(--back-color)",
                            fontWeight: 'bold',
                            border: 'none',
                            padding: '10px 20px'
                        }}
                        startIcon={<ArrowLeft sx={{ fontSize: 17 }} />}
                        style={{ textTransform: 'none' }}
                    >
                        Back to Matters
                    </Button>
                )}
            </Box>
            <Box
                sx={{
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    padding: 3,
                    backgroundColor: '#fff',
                    boxShadow: '0px 0px 4px rgba(0,0,0,0.05)',
                    mx: 2,
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                    {/* Title & Matter ID */}
                    <Box>
                        <Typography variant="h6" fontWeight={600}>
                            Kelvin - Age Discrimination
                        </Typography>
                        <Typography variant="body2" color="text.secondary" mb={2}>
                            GPGL-1234
                        </Typography>
                    </Box>
                    {/* Last Status Section */}
                    <Box display="flex" alignItems="center">
                        <Avatar
                            sx={{
                                backgroundColor: '#E3F2FD',
                                color: '#1E88E5',
                                width: 36,
                                height: 36,
                                mr: 2,
                            }}
                        >
                            <Volume2 style={{ fontSize: '20px' }} />
                        </Avatar>
                        <Box>
                            <Typography fontSize={13} fontWeight={500}>
                                Last Status Update
                            </Typography>
                            <Typography fontSize={12} color="text.secondary">
                                Jane Smith, May 30 2025, 10:00
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                {/* Key Fields in Grid Layout */}
                <Box display="flex" flexWrap="wrap" justifyContent="space-between" gap={4}>
                    <Box>
                        <Typography fontSize={13} color="text.secondary">
                            Matter Manager
                        </Typography>
                        <Typography fontWeight={600}>Jane Smith</Typography>
                    </Box>
                    <Box>
                        <Typography fontSize={13} color="text.secondary">
                            Matter Approver
                        </Typography>
                        <Typography fontWeight={600}>Jane Smith</Typography>
                    </Box>
                    <Box>
                        <Typography fontSize={13} color="text.secondary">
                            Estate Details
                        </Typography>
                        <Typography fontWeight={600}>Kelvin Smith Estate</Typography>
                    </Box>
                    <Box>
                        <Typography fontSize={13} color="text.secondary">
                            Family Tree
                        </Typography>
                        <Typography fontWeight={600}>Kelvin Smith Family Tree</Typography>
                    </Box>
                    <Box>
                        <Typography fontSize={13} color="text.secondary">
                            Client Name
                        </Typography>
                        <Typography fontWeight={600}>Kelvin Smith Family Tree</Typography>
                    </Box>
                </Box>
            </Box>
            <Box px={2}>
                {/* Tabs */}
                <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 1 }}>
                    <Tab label="Matters Details" />
                    <Tab label="Task" />
                    <Tab label="Files" />
                    <Tab label="Communication" />
                    {/* <Tab label="Communication Client" /> */}
                </Tabs>
                {/* Main Card */}
                <Box
                    sx={{
                        border: '1px solid #e0e0e0',
                        borderRadius: 2,
                        padding: 3,
                        backgroundColor: '#fff',
                    }}
                >
                    {/* Tab Panel Content */}
                    {tab === 0 && (
                        <Box
                            sx={{
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                padding: 3,
                                backgroundColor: '#fff',
                            }}
                        >
                            {/* Top Grid Section */}
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography fontSize={13} color="text.secondary">
                                        Name
                                    </Typography>
                                    <Typography color="primary" fontWeight={500}>
                                        Kelvin - Age Discrimination
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography fontSize={13} color="text.secondary">
                                        Matter Manager
                                    </Typography>
                                    <Typography fontWeight={500}>Jane Smith</Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography fontSize={13} color="text.secondary">
                                        Matter Approver
                                    </Typography>
                                    <Typography fontWeight={500}>Jane Smith</Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography fontSize={13} color="text.secondary">
                                        Matter Case ID
                                    </Typography>
                                    <Typography fontWeight={500}>GPGL-1234</Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography fontSize={13} color="text.secondary">
                                        Matter Client
                                    </Typography>
                                    <Typography fontWeight={500}>Kelvin Smith</Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography fontSize={13} color="text.secondary">
                                        Matter Type
                                    </Typography>
                                    <Typography fontWeight={500}>Employment Dispute</Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography fontSize={13} color="text.secondary">
                                        Team Assign
                                    </Typography>
                                    <Typography fontWeight={500}>Human Resources Legal</Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography fontSize={13} color="text.secondary">
                                        Matter Tag
                                    </Typography>
                                    <Box display="flex" gap={1} flexWrap="wrap">
                                        {['Discrimination', 'Age'].map((tag, index) => (
                                            <Chip
                                                key={index}
                                                label={tag}
                                                size="small"
                                                sx={{
                                                    backgroundColor: 'warning.dark',
                                                    color: '#fff',
                                                    fontWeight: 500,
                                                    fontSize: '12px',
                                                }}
                                            />
                                        ))}
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography fontSize={13} color="text.secondary">
                                        Priority
                                    </Typography>
                                    <Typography fontWeight={500} color="error">
                                        High
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography fontSize={13} color="text.secondary">
                                        Family Tree
                                    </Typography>
                                    <Typography fontWeight={500}>Kelvin Smith Family Tree</Typography>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography fontSize={13} color="text.secondary">
                                        Estate
                                    </Typography>
                                    <Typography fontWeight={500}>Kelvin Smith Estate</Typography>
                                </Grid>
                            </Grid>
                            {/* Matter Description Section */}
                            <Box mt={4}>
                                <Typography variant="h6" gutterBottom>
                                    Matters Details
                                </Typography>
                                <Typography fontSize={13} color="text.secondary" mb={1}>
                                    Matters Background
                                </Typography>
                                <Typography fontSize={14}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry...
                                </Typography>
                            </Box>
                            {/* Date Section */}
                            <Box mt={4} display="flex" gap={5}>
                                <Box>
                                    <Typography fontSize={13} color="text.secondary">
                                        Start Date
                                    </Typography>
                                    <Typography fontWeight={500}>May 30 2025</Typography>
                                </Box>
                                <Box>
                                    <Typography fontSize={13} color="text.secondary">
                                        Close Date
                                    </Typography>
                                    <Typography fontWeight={500}>May 30 2025</Typography>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    {tab === 1 && (
                        <Box
                            sx={{
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                padding: 3,
                                backgroundColor: '#fff',
                            }}
                        >
                            {/* Task Tab Content */}
                            <Typography fontSize={14} fontWeight={600}>
                                Tasks Related to the Matter
                            </Typography>
                            <Typography fontSize={13} color="text.secondary">
                                Task list and status will be shown here.
                            </Typography>
                        </Box>
                    )}
                    {tab === 2 && (
                        <Box
                            sx={{
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                padding: 3,
                                backgroundColor: '#fff',
                            }}
                        >
                            {/* Files Tab Content */}
                            <Typography fontSize={14} fontWeight={600}>
                                Uploaded Files
                            </Typography>
                            <Typography fontSize={13} color="text.secondary">
                                File attachments and document previews go here.
                            </Typography>
                        </Box>
                    )}
                    {tab === 3 && (
                        <Box
                            sx={{
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                padding: 3,
                                backgroundColor: '#fff',
                            }}
                        >
                            <ChatApp />
                        </Box>
                    )}

                    {tab === 4 && (
                        <Box
                            sx={{
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                padding: 3,
                                backgroundColor: '#fff',
                            }}
                        >
                            <ChatAppCopy />
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
}
